import { createContext, useContext, ReactNode } from 'react';

export interface SendMessageRequest {
  body: string;
  photos?: any[]; // PhotoFile[] - using any to avoid circular dependency
  photoUrl?: string; // Public URL of the uploaded photo (singular for now)
}

export interface MessageContextType {
  onSendMessage?: (message: SendMessageRequest) => Promise<void>;
  isPending?: boolean;
}

const MessageContext = createContext<MessageContextType>({});

export function MessageProvider({ 
  children, 
  onSendMessage, 
  isPending 
}: { 
  children: ReactNode;
  onSendMessage?: (message: SendMessageRequest) => Promise<void>;
  isPending?: boolean;
}) {
  return (
    <MessageContext.Provider value={{ onSendMessage, isPending }}>
      {children}
    </MessageContext.Provider>
  );
}

export function useMessageContext() {
  return useContext(MessageContext);
}
